/* Built In Imports */
/* External Imports */
import forEach from 'lodash/forEach';

/* Internal Imports */
/* Components */
import config from '@config';
import { tryGetPreviewData } from 'utils';

/* Services */
import { getLocale } from '@lb/components/Utility/Shared/SharedService';
import { IsoBackendHttpService } from 'utils/IsoBackendHttpService';
import { getLatestBuild } from './commonService';

let isCache = false;
const API_PREFIX = '/content/fetchiso';

export const getLandingPaths = async (
  level,
  url,
  contentType,
  notMatchText,
  matchType
) => {
  const data = config.BUILD_URLS?.LB?.enabled
    ? config.BUILD_URLS.LB
    : await getLatestBuild(
        process.env.NEXT_PUBLIC_BUILD_ID ||
          process.env.env_var_lb_build_id ||
          process.env.env_var_build_id
      );
  let urlArr = filterBuildUrls(
    contentType || 'linga_bhairavi_landing_page',
    level,
    url,
    notMatchText,
    data,
    matchType
  );
  return urlArr ? urlArr : [];
};

export const filterBuildUrls = (
  section,
  level,
  url,
  notMatchText,
  data,
  matchType = 'contains'
) => {
  let urls = [];
  // only urls with these patterns will be built
  // let isRegexFilters = ['/en/wisdom/article', '/sg/en/'];
  // to build everything , keep isRegexFilters empty
  // let isRegexFilters = [];
  const levelUrlArr = {
    lvl0: 4,
    L1: 5,
    L2: 6,
    L3: 7,
    L4: 8,
  };
  if (level === 'lvl0' || level === 'home_page') {
    if (data?.[level]?.length) {
      forEach(data[level], function (data) {
        if (data?.length < 200 && data.indexOf(url) > -1) {
          if (data?.split('/')?.length === levelUrlArr[level]) {
            let isAvailable = false;
            if (notMatchText && data.indexOf(notMatchText) > -1) {
              return;
            } else if (Array.isArray(notMatchText)) {
              // consoleLog('Array', notMatchText);
              forEach(notMatchText, function (link) {
                if (link && data.indexOf(link) > -1) {
                  isAvailable = true;
                }
              });
            }
            if (!isAvailable) {
              // consoleLog('data', data);
              urls.push(encodeURI(data));
            }
          }
        }
      });
    }
  } else if (
    level === 'L1' ||
    level === 'L2' ||
    level === 'L3' ||
    level === 'L4'
  ) {
    let buildSection = data && data[section];
    if (buildSection?.[level]?.length) {
      // consoleLog('if buildSection', buildSection?.[level]);
      forEach(buildSection[level], function (data, index) {
        if (data?.split('/')?.length === levelUrlArr[level]) {
          let isAvailable = false;
          if (matchType === 'contains') {
            if (data.indexOf(url) > -1) {
              if (notMatchText && data.indexOf(notMatchText) > -1) {
                return;
              } else if (Array.isArray(notMatchText)) {
                // consoleLog('Array', notMatchText, index);
                forEach(notMatchText, function (link) {
                  if (link && data.indexOf(link) > -1) {
                    isAvailable = true;
                  }
                });
              }
              if (!isAvailable) {
                // consoleLog('data', data);
                urls.push(encodeURI(data));
              }
            }
          } else if (matchType === 'startswith') {
            if (data.startsWith(url)) {
              if (notMatchText && data.indexOf(notMatchText) > -1) {
                return;
              } else if (Array.isArray(notMatchText)) {
                // consoleLog('Array', notMatchText, index);
                forEach(notMatchText, function (link) {
                  if (link && data.indexOf(link) > -1) {
                    isAvailable = true;
                  }
                });
              }
              if (!isAvailable) {
                // consoleLog('data', data);
                urls.push(encodeURI(data));
              }
            }
          } else if (matchType === 'endswith') {
            // consoleLog('matchType', matchType, url);
            if (data.endsWith(url)) {
              if (notMatchText && data.indexOf(notMatchText) > -1) {
                return;
              } else if (Array.isArray(notMatchText)) {
                // consoleLog('Array', notMatchText, index);
                forEach(notMatchText, function (link) {
                  if (link && data.indexOf(link) > -1) {
                    isAvailable = true;
                  }
                });
              }
              if (!isAvailable) {
                // consoleLog('data', data);
                urls.push(encodeURI(data));
              }
            }
          }
        }
      });
    }
  } else if (section === 'home_page') {
    const buildSection = data && data[section];
    if (buildSection?.length) {
      forEach(buildSection, function (data) {
        urls.push(encodeURI(data));
      });
    }
  }
  // consoleLog('urls', urls);
  return urls;
};

export const fetchDetails = async (region, lang, slug, previewData) => {
  if (previewData?.preview) {
    return await tryGetPreviewData(previewData, getLocale(region, lang, 'lb'));
  }
  const pageData = await new IsoBackendHttpService().get(
    `${API_PREFIX}/content`,
    !isCache,
    {
      params: {
        format: 'json',
        sitesection: 'lingabhairavi',
        slug: slug ? `${slug}` : `/`,
        region,
        lang,
      },
    }
  );
  return pageData;
};

export const fetchBlogData = async (
  contentType = '',
  sortby = 'newest',
  start = 0,
  limit = 12,
  topicUuid = '',
  searchKey = ''
) => {
  const allPosts = await new IsoBackendHttpService().get(
    `/content/fetchcsr/content`,
    !isCache,
    {
      params: {
        format: 'json',
        sitesection: 'lingabhairavi',
        slug: `blog`,
        contentType: contentType,
        sortby: sortby,
        start: start,
        limit: limit,
        topicUuid: topicUuid,
        searchKey: searchKey,
      },
    }
  );

  // console.log('Posts loaded', {
  //   params: {
  //     format: 'json',
  //     sitesection: 'lingabhairavi',
  //     slug: `blog`,
  //     contentType: contentType,
  //     sortby: sortby,
  //     start: start,
  //     limit: limit,
  //     topicUuid: topicUuid,
  //     searchKey: searchKey
  //   },
  //   allPosts
  // });
  return allPosts;
};
